import React from "react";
import styles from "./Select.module.scss";

export default function Select({ children, compact = false, ...selectProps }) {
  return (
    <div className={styles.wrap}>
      <select
        className={compact ? styles.compact : styles.select}
        {...selectProps}
      >
        {children}
      </select>
      <div className={compact ? styles.compactCarret : styles.carret} />
    </div>
  );
}
